// extracted by mini-css-extract-plugin
module.exports = {"aboveTheFoldEventsTable":"DesktopProfileActivityFeed_aboveTheFoldEventsTable__2UIky","nounbrInfoPadding":"DesktopProfileActivityFeed_nounbrInfoPadding__3gVlG"};